export class ThematicBoxEntry {
    constructor(layer_id, name, visible) {
        this.repr = $(this.html(layer_id, visible, name));
    }
    html(id, checked, name) {
        return `<div class="layer${checked ? ' active' : ''}">
                <label>
                    <input type="radio" id="${id}" name="${name}" ${checked ? 'checked' : ''} />
                    <span>${name}</span>                  
                </label>
            </div>`;
    }
    get $input() {
        return this.repr.find('input:radio');
    }
}
